import { Post } from "../types/Post";
import { ApiURL, Request } from "@services/api.service";

export const PostDao = {
    getOne: async (post: string, platform: string): Promise<Post> => {
        try {
            const info: any = await Request(ApiURL + `post/info/get`, {
                headers: { "Content-type": "application/json" },
                method: "POST",
                body: JSON.stringify({ post, platform }),
            })
            const stat: any = await Request(ApiURL + `post/stat/get`, {
                headers: { "Content-type": "application/json" },
                method: "POST",
                body: JSON.stringify({ post, platform }),
            })
            return new Post({ ...stat.content, ...info.content })
        } catch (error: any) {
            console.error(error)
            return error
        }
    }
}


